<template>
  <div class="create-contest-wrapper">
    <div class="container">
      <div class="create-contest-page-container">
        <div class="create-contest-main-content">
          <div class="card w-100">
            <h3>Create new contest</h3>
            <div class="create-contest-fields">
              <input type="text" class="input w-70" placeholder="Contest name" v-model="name">
              <input type="text" class="input w-70" placeholder="Short description" v-model="description">
              <div class="flex-row flex-wrap row-gap-1 w-70">
                <div class="labeled-input w-50">
                  <label for="start">Start date</label>
                  <input type="date" id="start" class="input w-40" v-model="start">
                </div>
                <div class="labeled-input w-50">
                  <label for="end">End date</label>
                  <input type="date" id="end" class="input w-40" v-model="end">
                </div>
                <div class="labeled-input w-50">
                  <label for="quantity">Allowed images</label>
                  <input type="number" id="quantity" min="1" max="99" class="input w-40" placeholder="1"
                         v-model="imageLimit">
                </div>
                <div class="labeled-input w-50">
                  <label for="org-selection">Restrict to organization</label>
                  <select class="org-select" id="org-selection input" v-model="selectedOrg">
                    <option value="null" selected="selected">no restriction</option>
                    <option v-for="org in orgs" :key="org.id" :value="org.id">{{ org.name }}</option>
                  </select>
                </div>
              </div>
              <textarea placeholder="Rules" rows="10" v-model="rules" class="input w-70"></textarea>
              <div>
                <button class="button-primary mr-10" @click="createContest">Create</button>
                <button class="button-warning" @click="back">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import apiService from '@/services/apiService';
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';

const router = useRouter();

const name = ref('')
const description = ref('')
const start = ref(null)
const end = ref(null)
const imageLimit = ref(1)
const rules = ref('')
const orgs = ref([])
const selectedOrg = ref(null)

function back() {
  router.back();
}

onMounted(() => getOrganizations());

async function createContest() {
  const data = {
    name: name.value,
    description: description.value,
    start_date: start.value,
    end_date: end.value,
    image_limit: imageLimit.value,
    rules: rules.value,
    org_id: selectedOrg.value
  }

  const contest = await apiService.createContest(data)

  router.push(`/contests/${contest.id}`)
}

async function getOrganizations() {
  orgs.value = await apiService.getOrganizations()
}

</script>

<style scoped>
.create-contest-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.create-contest-page-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;
}

.create-contest-main-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-right: 1rem;
}

.create-contest-fields {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  gap: 15px;
}

.labeled-input {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.org-select {
  padding: 0.4rem;
  border: 1px solid lightgray;
  border-radius: 10px;
  background-color: white;
}
</style>